<template>
  <div class="docs-menu-container">
    <el-menu
      :default-active="currentId"
      active-text-color="#36f"
      class="el-menu-vertical-demo"
      @select="handleSelect"
    >
      <el-submenu :index="'' + item.id" v-for="item in menuList" :key="item.id">
        <template slot="title">
          <span>{{ item.name }}</span>
        </template>
        <el-submenu
          :index="'' + submenu.id"
          v-for="submenu in item.childrenList"
          :key="submenu.id"
        >
          <template slot="title">{{ submenu.name }}</template>
          <el-menu-item
            :index="'' + subblog.id"
            v-for="subblog in submenu.articleList"
            :key="subblog.id"
            ><div class="blog_name" :title="subblog.title">
              {{ subblog.title }}
            </div></el-menu-item
          >
        </el-submenu>
        <el-menu-item
          :index="'' + blog.id"
          v-for="blog in item.articleList"
          :key="blog.id"
          ><div class="blog_name" :title="blog.title">{{ blog.title }}</div>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    currentId: {
      default: "",
      type: String,
    },
    menuList: {
      default: () => [],
      type: Array,
      require: true,
    },
  },

  methods: {
    handleSelect(e) {
      if (this.currentId !== e) {
        this.$emit("changeBlog", e);
      }
    },
  },
};
</script>

<style lang="scss">
.docs-menu-container {
  background: #fafafa;
  user-select: none;
  .el-menu {
    border-right: none;
  background: #fafafa;
  }
  .el-menu-item,
  .el-submenu__title {
    height: 35px !important;
    line-height: 35px !important;
  }
  .el-menu-item {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.65);
    &:hover {
      color: #36f;
    }
  }
  .el-submenu,
  .el-submenu__title {
    color: #576b95;
  }
  .el-menu-item:focus,
  .el-menu-item:hover,
  .el-submenu__title:hover {
    background: #fff;
  }
}
</style>
<style lang="scss" scoped>
.docs-menu-container {
  .blog_name {
    width: 100%;
    overflow: hidden; /* 超出部分隐藏 */
    white-space: nowrap; /* 文本不换行 */
    text-overflow: ellipsis;
    font-size: 14px;
  }
}
</style>